import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import routes from '../routes';
import { AppRouteComponentMatchParams } from '../typescriptHelpers';
import workflowsPlatformAndroidMdm from '../../assets/workflows-platform-android-mdm.svg';

// TEMPORARY: DoorDash "Hubble Kiosk" is on the real `react-native-ota` platform but is distributed via
// MDM, so we display it as "MDM" (label + icon). Display-only: no new AppPlatform, no release logic.
// Keyed on the customer-facing App.appId so it survives renames.
//
// To remove: delete this file, its spec and workflows-platform-android-mdm.svg, then let tsc point at
// every call site — each reverts to plain displayTextForAppPlatform / WorkflowsPlatformIcon.
export const MDM_ORG_ID = 'doordash';
export const MDM_APP_ID = 'hubble-kiosk-react-native-ota';

export const MDM_TESTING_ORG_ID = 'runway-org';
export const MDM_TESTING_APP_ID = 'mobile-device-management-react-native-ota';

interface OrgRouteParams {
    orgIdParam: string;
}

export interface MdmPlatformOverride {
    label: string;
    icon: (size: number) => React.ReactNode;
}

export function getMdmPlatformOverride(
    orgId: string | null | undefined,
    appId: string | null | undefined,
): MdmPlatformOverride | null {
    const matchesTargetApp = orgId === MDM_ORG_ID && appId === MDM_APP_ID;
    const matchesTestingApp = orgId === MDM_TESTING_ORG_ID && appId === MDM_TESTING_APP_ID;

    if (!matchesTargetApp && !matchesTestingApp) {
        return null;
    }

    return {
        label: 'MDM',
        icon: (size) => (
            <img src={workflowsPlatformAndroidMdm} width={size} height={size} style={{ flexShrink: 0 }} alt="" />
        ),
    };
}

export function useMdmPlatformOverride(appId?: string): MdmPlatformOverride | null {
    const resolveOverride = useMdmPlatformOverrideResolver();
    return resolveOverride(appId);
}

export function useMdmPlatformOverrideResolver(): (appId?: string) => MdmPlatformOverride | null {
    const orgId = useRouteMatch<OrgRouteParams>(routes.org)?.params?.orgIdParam;
    const routeAppId = useRouteMatch<AppRouteComponentMatchParams>(routes.app)?.params?.appIdParam;
    return (appId) => getMdmPlatformOverride(orgId, appId ?? routeAppId);
}
